<style lang="scss">
@import "@/assets/sass/pages/wizard/wizard-3.scss";
</style>

<script>
// import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import KTUtil from "@/assets/js/components/util";
import KTWizard from "@/assets/js/components/wizard";
import Swal from "sweetalert2";
import Locations from "@/view/components/lpm/wizard-steps/Locations.vue";
import RedemptionChannel from "@/view/components/lpm/wizard-steps/RedemptionChannel.vue";
import MaxBudget from "@/view/components/lpm/wizard-steps/MaxBudget.vue";
import CampaignDetails from "@/view/components/lpm/wizard-steps/CampaignDetails.vue";
import CampaignPeriod from "@/view/components/lpm/wizard-steps/CampaignPeriod.vue";
import Payment from "@/view/components/lpm/wizard-steps/Payment.vue";
import swal from "sweetalert";
export default {
  name: "Wizard-form",
  components: {
    Locations,
    RedemptionChannel,
    MaxBudget,
    CampaignDetails,
    CampaignPeriod,
    Payment
  },
  data() {
    return {
      wizard: null,
      locations: [],
      swap: false
    };
  },
  async mounted() {
    await this.$store.dispatch("getLocations");
    setTimeout(() => {
      this.swap = false;
      this.swap = true;
      // this.$store.dispatch(SET_BREADCRUMB, [
      //   { title: "Wizard", route: "wizard-1" },
      //   { title: "Wizard-3" }
      // ]);
      // Initialize form wizard
      const wizard = new KTWizard("kt_wizard_v3", {
        startStep: 1, // initial active step number
        clickableSteps: false // allow step clicking
      });
      // Validation before going to next page
      // wizard.on("beforeNext", function(/*wizardObj*/) {
        // validate the form and use below function to stop the wizard's step
        // wizardObj.stop();
      // });
      // Change event
      wizard.on("change", function(/*wizardObj*/) {
        setTimeout(() => {
          KTUtil.scrollTop();
        }, 500);
      });
      this.wizard = wizard;
    }, 2000);
  },
  computed: {
    getLocations() {
      return this.$store.getters["getLpmLocations"];
    }
  },
  watch: {
    getLocations(newVal) {
      this.locations = newVal;
    }
  },
  methods: {
    close() {
      this.$emit("input", false);
    },
    handleLocationChanges(newObject) {
      this.$store.commit("setLpmLocations", newObject);
    },
    setup() {
      // console.log("this.wizard.currentStep", this.wizard.currentStep);
      if (this.wizard.currentStep === 2) {
        this.valiateStep2();
      }
      if (this.wizard.currentStep === 3) {
        this.valiateStep3();
      }
      if (this.wizard.currentStep === 4) {
        this.valiateStep4();
      }
    },
    valiateStep2() {
      // console.log("Step 2 Validation");
      let redemptions = [];
      this.locations.map(location => {
        let redemption = document.getElementById(`my_redemption_${location.id}`)
          .value;
        if (redemption) {
          redemptions.push(redemption);
        }
      });
      // console.log(this.locations.length, redemptions.length);
      if (this.locations.length !== redemptions.length) {
        swal("Step 2", "Please select locations redemption channel");
        this.wizard.stop();
      }
    },
    valiateStep3() {
      // console.log("Step 3 Validation");
      let selectedSpend = document.querySelector(
        'input[name="selectedSpend"]:checked'
      );
      if (!selectedSpend) {
        swal("Step 3", "Please choose campaign budget options");
        this.wizard.stop();
      }
      if (selectedSpend && selectedSpend.value) {
        // console.log("selectedSpend", selectedSpend.value);
        if (selectedSpend.value === "all store") {
          let max_campaign_budget = document.getElementById(
            `max_campaign_budget`
          ).value;
          let max_monthly_budget = document.getElementById(`max_monthly_budget`)
            .value;
          if (!max_campaign_budget && !max_monthly_budget) {
            swal(
              "Step 3",
              "Please enter an amount for maximum budget for all locations"
            );
            this.wizard.stop();
          }
        }
        if (selectedSpend.value === "per store") {
          let no_budgets_selected = 0;
          this.locations.map(location => {
            let max_campaign_budget = document.getElementById(
              `max_campaign_budget_${location.id}`
            ).value;
            let max_monthly_budget = document.getElementById(
              `max_monthly_budget_${location.id}`
            ).value;
            if (!max_campaign_budget && !max_monthly_budget) {
              no_budgets_selected = no_budgets_selected + 1;
            }
          });
          // console.log("no_budgets_selected", no_budgets_selected);
          if (no_budgets_selected > 0) {
            swal(
              "Step 3",
              "Please enter an amount for maximum budget per location"
            );
            this.wizard.stop();
          }
        }
      }
    },
    valiateStep4() {
      // console.log("Step 4 validation");
      let campaign_name = document.getElementById(`campaign_name`).value;
      // let campaign_logo = document.getElementById(`campaign_logo`).value;
      // let campaign_copy = document.getElementById(`campaign_copy`).value;
      // let terms_conditions = document.getElementById(`terms_conditions`).value;
      // console.log("campaign_name", campaign_name);
      if (!campaign_name || campaign_name === "") {
        swal("Step 4", "Please enter your campaign name");
        this.wizard.stop();
      }
    },
    valiateStep6() {
      console.log("Step 6 validation");
      let isValid = true;
      let cardholder_name = document.getElementById(`cardholder_name`).value;
      if (!cardholder_name || cardholder_name === "") {
        isValid = false;
        swal("Step 6", "Please enter card holder's name");
        this.wizard.stop();
      }
      let card_number = document.getElementById(`card_number`).value;
      if (!card_number || card_number === "") {
        isValid = false;
        swal("Step 6", "Please enter card number");
        this.wizard.stop();
      }
      let card_cvv = document.getElementById(`card_cvv`).value;
      if (!card_cvv || card_cvv === "") {
        isValid = false;
        swal("Step 6", "Please enter card cvv");
        this.wizard.stop();
      }
      let card_expiration_date = document.getElementById(`card_expiration_date`)
        .value;
      if (!card_expiration_date || card_expiration_date === "") {
        isValid = false;
        swal("Step 6", "Please enter card expiration date");
        this.wizard.stop();
      }
      return isValid;
    },
    submit: function(e) {
      e.preventDefault();
      if (this.wizard.currentStep === 6) {
        let isvalid = this.valiateStep6();
        if (!isvalid) {
          return;
        }
      }
      Swal.fire({
        title: "",
        text: "The application has been successfully submitted!",
        icon: "success"
      });
    }
  }
};
</script>

<template>
  <v-app>
    <v-container>
      <div class="card card-custom">
        <div class="card-body p-0">
          <!--begin: Wizard-->
          <div
            class="wizard wizard-3"
            id="kt_wizard_v3"
            data-wizard-state="step-first"
            data-wizard-clickable="true"
          >
            <!--begin: Wizard Nav -->
            <div class="wizard-nav border-bottom mb-1 mb-lg-5">
              <div class="wizard-steps px-8 py-8 px-lg-15 py-lg-3">
                <div
                  class="wizard-step"
                  data-wizard-type="step"
                  data-wizard-state="current"
                >
                  <div class="wizard-label">
                    <h3 class="wizard-title"><span>1</span> Setup Location</h3>
                    <div class="wizard-bar"></div>
                  </div>
                </div>
                <div class="wizard-step" data-wizard-type="step">
                  <div class="wizard-label">
                    <h3 class="wizard-title">
                      <span>2</span> Redemption Channels
                    </h3>
                    <div class="wizard-bar"></div>
                  </div>
                </div>
                <div class="wizard-step" data-wizard-type="step">
                  <div class="wizard-label">
                    <h3 class="wizard-title"><span>3</span> Budget</h3>
                    <div class="wizard-bar"></div>
                  </div>
                </div>
                <div class="wizard-step" data-wizard-type="step">
                  <div class="wizard-label">
                    <h3 class="wizard-title"><span>4</span> Details</h3>
                    <div class="wizard-bar"></div>
                  </div>
                </div>
                <div class="wizard-step" data-wizard-type="step">
                  <div class="wizard-label">
                    <h3 class="wizard-title"><span>5</span> Campaign Period</h3>
                    <div class="wizard-bar"></div>
                  </div>
                </div>
                <div class="wizard-step" data-wizard-type="step">
                  <div class="wizard-label">
                    <h3 class="wizard-title"><span>6</span> Payment</h3>
                    <div class="wizard-bar"></div>
                  </div>
                </div>
              </div>
            </div>
            <!--end: Wizard Nav -->

            <!--begin: Wizard Body-->
            <div class="row justify-content-center py-5 px-2 py-lg-5 px-lg-5">
              <div class="col-xl-12 col-xxl-12">
                <!--begin: Wizard Form-->
                <form class="form" id="kt_form">
                  <!--begin: Wizard Step 1-->
                  <div
                    class="pb-5"
                    data-wizard-type="step-content"
                    data-wizard-state="current"
                  >
                    <h4 class="mb-2 font-weight-bold text-dark">
                      Step 1
                    </h4>
                    <locations
                      v-if="swap"
                      @input="handleLocationChanges"
                    ></locations>
                  </div>
                  <!--end: Wizard Step 1-->

                  <!--begin: Wizard Step 2-->
                  <div class="pb-5" data-wizard-type="step-content">
                    <h4 class="mb-2 font-weight-bold text-dark">
                      Step 2
                    </h4>
                    <redemption-channel></redemption-channel>
                  </div>
                  <!--end: Wizard Step 2-->

                  <!--begin: Wizard Step 3-->
                  <div class="pb-5" data-wizard-type="step-content">
                    <h4 class="mb-2 font-weight-bold text-dark">
                      Step 3
                    </h4>
                    <max-budget></max-budget>
                  </div>
                  <!--end: Wizard Step 3-->

                  <!--begin: Wizard Step 4-->
                  <div class="pb-5" data-wizard-type="step-content">
                    <h4 class="mb-2 font-weight-bold text-dark">
                      Step 4
                    </h4>
                    <campaign-details></campaign-details>
                  </div>
                  <!--end: Wizard Step 4-->
                  <!--begin: Wizard Step 5-->
                  <div class="pb-5" data-wizard-type="step-content">
                    <h4 class="mb-2 font-weight-bold text-dark">
                      Step 5
                    </h4>
                    <campaign-period></campaign-period>
                  </div>
                  <!--end: Wizard Step 5-->

                  <!--begin: Wizard Step 6-->
                  <div class="pb-5" data-wizard-type="step-content">
                    <h4 class="mb-2 font-weight-bold text-dark">
                      Step 6
                    </h4>
                    <payment></payment>
                  </div>
                  <!--end: Wizard Step 6-->

                  <!--begin: Wizard Actions -->
                  <div class="d-flex justify-content-between border-top pt-10">
                    <div class="mr-2">
                      <button
                        class="btn btn-light-primary font-weight-bold text-uppercase px-9 py-4"
                        data-wizard-type="action-prev"
                      >
                        Previous
                      </button>
                    </div>
                    <div>
                      <button
                        type="button"
                        class="btn btn-danger font-weight-bold text-uppercase px-9 py-4 mr-5"
                        @click="close"
                      >
                        Close
                      </button>
                      <button
                        v-on:click="submit"
                        class="btn btn-success font-weight-bold text-uppercase px-9 py-4"
                        data-wizard-type="action-submit"
                        :disabled="locations.length === 0"
                      >
                        Submit
                      </button>
                      <button
                        class="btn btn-primary font-weight-bold text-uppercase px-9 py-4"
                        data-wizard-type="action-next"
                        @click="setup"
                      >
                        Next Step
                      </button>
                    </div>
                  </div>
                  <!--end: Wizard Actions -->
                </form>
                <!--end: Wizard Form-->
              </div>
            </div>
            <!--end: Wizard Body-->
          </div>
          <!--end: Wizard-->
        </div>
      </div>
    </v-container>
  </v-app>
</template>
